import { FC, useCallback, AnchorHTMLAttributes } from 'react'
import styles from 'components/features/pfm/LinkedAccountTooltip/AccountTooltipLink.styl'
import { MarkdownLinkElement } from 'interfaces/format'
import { startLinkageSessionActionCreator } from 'actions/linkageActions'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { createCompositeId } from 'helpers/linkageHelpers'

type AccountTooltipLinkProps = MarkdownLinkElement

export const AccountTooltipLink: FC<AccountTooltipLinkProps> = (props) => {
  const { label, expression, colonTokens } = props

  const isAction = colonTokens[0] === 'action'

  const dispatch = useStoreDispatch()
  const handleActionClick = useCallback(() => {
    if (colonTokens.length > 1 && colonTokens[1] === 'suggest_manual_account') {
      dispatch(
        startLinkageSessionActionCreator.request({
          cid: createCompositeId('manual-balance-account', null),
        })
      )
    }
  }, [dispatch, colonTokens])

  const actionLinkProps: Partial<AnchorHTMLAttributes<HTMLAnchorElement>> = {
    onClick: handleActionClick,
  }

  const commonLinkProps: Partial<AnchorHTMLAttributes<HTMLAnchorElement>> = {
    href: expression,
    target: '_blank',
    rel: 'noopener noreferrer',
  }

  const restProps: Partial<AnchorHTMLAttributes<HTMLAnchorElement>> = {
    children: label,
    ...(isAction ? actionLinkProps : commonLinkProps),
  }

  return (
    <a
      key={ expression }
      className={ styles.tooltipActionLink }
      { ...restProps }
    />
  )
}
